// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__2L8EV","title":"Error_title__134yJ"};